export default {"src":"/_next/static/media/squareFilled.fc461760.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};